import { useCallback } from 'react'

import { useDropzone } from 'react-dropzone'

import { DropzoneContainer } from './styled';

export function FileDropzone(props: any) {
    const { onSelectFile } = props

    const onDrop = useCallback(acceptedFiles => {
        onSelectFile(acceptedFiles[0]);
    }, [])

    const { getRootProps, getInputProps } = useDropzone({ onDrop, maxFiles: 1 });


    return (
        <>
            <div>
                <DropzoneContainer {...getRootProps({ className: 'dropzone cursor-pointer' })}>
                    <input {...getInputProps()} />
                    <p style={{ margin: '0px' }}>Adicionar arquivo</p>
                </DropzoneContainer>
            </div>
        </>
    )
}